import React, {useEffect, useState} from 'react';
import {subscribe, availableSessionsModal, cursusModal} from 'actions';
import {useDispatch} from 'react-redux';
import LazyLoadImageComponent from "common/components/LazyLoadImage";
import {t} from 'translates';
import classNames from 'classnames';
import storage from 'storage';
import ProductCard from '../../../common/components/ProductCard';

const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

function Product(props) {
  const dispatch = useDispatch();
  const ecommerceStatus = window.drupalSettings && window.drupalSettings.ecommerceStatus ? window.drupalSettings.ecommerceStatus : false;
  const bookCtaLabel = window.drupalSettings && window.drupalSettings.bookCtaLabel && window.drupalSettings.bookCtaLabel.length > 0 ? window.drupalSettings.bookCtaLabel : '';
  const waitlistStatus = window.drupalSettings && window.drupalSettings.waitlistStatus;
  const [isFirstVisible, setIsFirstVisible] = useState(false);

  const {
    title,
    description,
    id,
    image,
    price_string,
    sessions_data,
    series_data,
    category_name,
    color,
    url,
    is_big,
    type,
    is_3rd_party_subscription,
    isVisible,
    tracking,
    index,
    itemListName,
  } = props;

  useEffect(() => {
    if (isVisible) {
      setIsFirstVisible(true);
    }
  }, [isVisible]);

  useEffect(() => {
    if (isFirstVisible) {
      window.dataLayer && window.dataLayer.push({
        'event': 'view_item_list',
        'ecommerce': {
          'currency': tracking.currency_code,
          'items': [{
            'item_id': tracking.id,
            'item_name': tracking.title,
            'item_category': tracking.category_name,
            'item_available': tracking.is_available,
            'price': tracking.price,
            'item_type': tracking.category_type,
            'index': index,
            'item_list_id': pg_type + ' - ' + itemListName + ' - ' + window.location.pathname,
            'item_list_name': itemListName,
          }]
        }
      });
    }
  }, [isFirstVisible]);

  const handleClickGTM = () => {
    window.dataLayer && window.dataLayer.push({
      'event': 'select_item',
      'ecommerce': {
        'currency': tracking.currency_code,
        'items': [{
          'item_id': tracking.id,
          'item_name': tracking.title,
          'item_category': tracking.category_name,
          'item_available': tracking.is_available,
          'price': tracking.price,
          'item_type': tracking.category_type,
          'index': index,
          item_list_name: itemListName || '',
          item_list_id: pg_type + ' - ' + (itemListName || '') + ' - ' + window.location.pathname,
        }]
      }
    });

    storage.set('analytics.' + tracking.id, {
      'pg_type': pg_type,
      'item_list_name': itemListName,
      'url': window.location.pathname,
      'index': index,
      'timestamp': Date.now()
    });
  }

  const handleAuxClick = (event) => {
    if (event.button === 1) {
      handleClickGTM();
    }
  }

  const handleClickBookNow = (e) => {
    e.preventDefault();

    handleClickGTM();
    dispatch(availableSessionsModal.fetch(id, props));
    dispatch(availableSessionsModal.setSelectedProduct(props));

    return false;
  };

  const handleClickBookNowCursus = (e) => {
    e.preventDefault();
    dispatch(cursusModal.fetch(id));

    window.dataLayer && window.dataLayer.push({
      event: "seeOtherDates",
      "productRef": url
    });
    return false;
  };

  const handleClickWaitlist = (e) => {
    e.preventDefault();
    dispatch(subscribe.fetch(id, url));

    return false;
  };

  const button = () => {
    if (type === 'product') {
      if (is_3rd_party_subscription) {
        return (
          <a
            href={url}
            className="session-new__btn"
            onClick={handleClickGTM}
            onAuxClick={handleAuxClick}
          >
            {(bookCtaLabel.length > 0) ? bookCtaLabel : t('Book now', DT_SESSIONS)}
          </a>
        );
      }

      if (sessions_data.is_available) {
        return (
          <a
            href={`#${id}`}
            className="session-new__btn"
            onClick={handleClickBookNow}
          >
            {(bookCtaLabel.length > 0) ? bookCtaLabel : t('Book now', DT_SESSIONS)}
          </a>
        );
      }
      return (
        <div>
          {waitlistStatus && (
            <a
              href={`#${id}`} className="session-new__btn session-new__btn--white"
              onClick={handleClickWaitlist}
            >
              {t('Subscribe to wait list', DT_SESSIONS)}
            </a>
          )}
        </div>
      );
    }

    if (type === 'cursus') {
      if (series_data.isAvailable) {
        return (
          <a
            href={url}
            className="session-new__btn"
            onClick={handleClickGTM}
            onAuxClick={handleAuxClick}
          >
            {(bookCtaLabel.length > 0) ? bookCtaLabel : t('Book now', DT_SESSIONS)}
          </a>
        );
      }
      return (
        <a
          href={url}
          onClick={handleClickGTM}
          className="session-new__btn session-new__btn--white"
        >
          {t('Coming soon', DT_CURSUS)}
        </a>
      );
    }
  };

  return (
      <ProductCard
        type={type}
        series_data={series_data}
        is_big={is_big}
        product_category={category_name}
        product_category_color={color}
        product_description={description}
        product_title={title}
        url={url}
        full_price={price_string}
        product_image={image.uri}
        date={sessions_data && sessions_data.date}
        time={sessions_data && sessions_data.time}
        session_languages={sessions_data && sessions_data.language}
        sessions_count_label={sessions_data && sessions_data.available_label}
        in_stock={sessions_data && sessions_data.is_available}
        subscription_3rd_party={is_3rd_party_subscription}
        trackingEvent={handleClickGTM}
        has_session={sessions_data && sessions_data.available_label}
        handleClickBookNow={handleClickBookNow}
        handleClickWaitlist={handleClickWaitlist}
      />
  );
}

export default Product;
